/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { getActiveQueryClient } from "../lib/queryClient";
import { clearAdmin } from "../store/adminSlice";
import { SESSION_KEYS } from "../lib/authConstants";

export async function resetAppState() {
  const queryClient = getActiveQueryClient();

  if(queryClient) {
    // Cancel any in-flight queries
    await queryClient.cancelQueries();
  
    // Clears all the tanstack query cache
    queryClient.clear();
  }

  // Clears admin redux
  if (window.__REDUX_STORE__) {
    window.__REDUX_STORE__.dispatch(clearAdmin());
  }

  // Clears browser Storage
  sessionStorage.clear();
  localStorage.removeItem(SESSION_KEYS.AUTH_TOKEN);
  localStorage.removeItem(SESSION_KEYS.IS_AUTHENTICATED);
  localStorage.removeItem(SESSION_KEYS.USER_DATA);
  localStorage.removeItem(SESSION_KEYS.LAST_ACTIVITY);
  localStorage.removeItem(SESSION_KEYS.SESSION_START);
}
